import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Pipe({
  name: 'disableFormControlName',
  standalone: true
})
export class DisableFormControlNamePipe implements PipeTransform {

  transform(form: UntypedFormControl, fieldName: string, disable = true): void {

    if (disable) {
      form?.get(fieldName).disable();
    } else {
      form?.get(fieldName).enable();
    }

  }

}
